module.exports = __webpack_public_path__ + "static/media/Facebook_Logo.1d814beb.svg";